export default __webpack_public_path__ + "static/media/footer3.511cd910.jpg";